module.exports = __webpack_public_path__ + "static/media/calliptamus_italicus_001_APA.864b49a8.mp3";